import { useMutation, useQueryClient } from '@tanstack/react-query';
import { HealthcareFacilitiesApi } from '../../../apis/HealthcareFacilitiesApi/HealthcareFacilitiesApi';
import { IHealthcareFacilityDefaultTaskInput } from '../HealthcareFacility';
import { AppMedError } from '../../../error/AppMedError';

export function usePostDefaultTasksForFacility() {
    const queryClient = useQueryClient();

    return useMutation<void, AppMedError, { facilityId: number; tasks: IHealthcareFacilityDefaultTaskInput[] }>({
        mutationFn: async ({ facilityId, tasks }) => {
            await HealthcareFacilitiesApi.postDefaultTasksForFacility(facilityId, tasks);
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['defaultTasksByFacilityId', variables.facilityId] });
        },
    });
}

